import React from 'react';
import { Icon } from 'ui';

const localizedIconNames = {
  en: 'expert_learn',
  es: 'expert_learn_es',
  fr: 'expert_learn_fr',
  de: 'expert_learn_de',
  pt: 'expert_learn_pt',
  it: 'expert_learn_it',
  sv: 'expert_learn_sv',
  nl: 'expert_learn_nl',
  ru: 'expert_learn_ru',
  ja: 'expert_learn_ja',
  'zh-CN': 'expert_learn_zh_cn',
  ar: 'expert_learn_ar',
};

const LearnExpertIcon = () => {
  const name = localizedIconNames[I18n.locale] || 'expert_learn_blank';
  return <Icon className="LearnExpertIcon mr-8 fz-20" name={name} />;
};

export default LearnExpertIcon;
